import axios from 'axios';

const wolfApi = axios.create({
  baseURL: process.env.WOLF_URI,
});

export default wolfApi;

export const getWolfFileByUrl = (url: string) =>
  wolfApi.get<Blob>(url, { responseType: 'arraybuffer' }).then(response => response);
